<template>
    <DetailTemplate :customClass="'detail-page'" v-if="getPermission('setting:view')">
        <template v-slot:header-title>
            <div class="d-flex">
                <template v-if="pageLoading">

                    <v-skeleton-loader class="custom-skeleton" width="400" height="28" type="text">
                    </v-skeleton-loader>
                    <v-skeleton-loader class="custom-skeleton height-30px my-auto mx-2 custom-skeleton-full-width" width="130" type="text">
                    </v-skeleton-loader>
                </template>
                <template v-else>
                    <h1 class="form-title custom-nowrap-ellipsis text-capitalize">
                        {{ getPageTitle }}
                    </h1>
                    <v-chip :color="getColor(templateArr.activated)" label class="ml-2">
                        <span class="font-size-16 font-weight-500">
                            {{ getStatus(templateArr.activated) }}
                        </span>
                    </v-chip>
                </template>
            </div>
        </template>
        <template v-slot:header-action>
            <!-- <template>
                <template>
                    <v-tooltip top content-class="custom-top-tooltip">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn depressed :disabled="pageLoading" class="mx-2 custom-bold-button white--text"
                                color="cyan" v-bind="attrs" v-on="on" v-on:click="updateServiceFormTemplate()">
                                <v-icon left>mdi-pencil</v-icon> Edit
                            </v-btn>
                        </template>
                        <span>Click here to edit Service Form Template</span>
                    </v-tooltip>
                </template>
            </template> -->
            <v-btn depressed class="mx-2 custom-grey-border custom-bold-button" v-on:click="goBack">
                <v-icon small left>mdi-keyboard-backspace</v-icon>
                Back
            </v-btn>
        </template>
        <template v-slot:body>
            <v-tabs v-model="templateTab" background-color="transparent" color="cyan" class="custom-tab-transparent">
                <v-tab class="font-size-16 font-weight-600 px-8" href="#property">
                    <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
                        <!--begin::Svg Icon-->
                        <inline-svg :src="$assetURL('media/custom-svg/property.svg')" />
                        <!--end::Svg Icon-->
                    </span>
                    Overview
                </v-tab>
                <v-tab class="font-size-16 font-weight-600 px-8" href="#equipment">
                    <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
                        <!--begin::Svg Icon-->
                        <inline-svg :src="$assetURL('media/custom-svg/equipment.svg')" />
                        <!--end::Svg Icon-->
                    </span>
                    Categories
                </v-tab>
            </v-tabs>
            <perfect-scrollbar :options="{ suppressScrollX: true }" class="scroll"
                style="height: 84vh; position: relative">
                <v-tabs-items v-model="templateTab">
                    <v-tab-item v-if="getPermission('property:view')" :value="'property'">
                        <template>
                            <v-container fluid>
                                <v-row>
                                    <v-col md="4" class="custom-border-right">
                                        <table class="width-100">
                                            <tr>
                                                <td class="pb-2 font-size-18 font-weight-500 text-capitalize">
                                                    Title
                                                </td>
                                                <td class="pb-2 font-size-18 text-capitalize">
                                                    <template v-if="templateArr.title">
                                                        {{ templateArr.title }}
                                                    </template>
                                                    <template v-else>
                                                        <em class="text--secondary">No Title</em>
                                                    </template>
                                                </td>
                                            </tr>
                                            <!-- <tr>
                                                <td class="pb-2 font-size-18 font-weight-500 text-capitalize">
                                                    Category Count
                                                </td>
                                                <td class="pb-2 font-size-18 text-capitalize">
                                                    <template v-if="templateArr.categories_count">
                                                        <v-avatar size="22" color="blue" class="white--text" left>
                                                            {{ templateArr.categories_count }}
                                                        </v-avatar>
                                                    </template>
                                                </td>
                                            </tr> -->
                                            <!-- <tr>
                                                <td class="pb-2 font-size-18 font-weight-500 text-capitalize" width="20%">
                                                    Category
                                                </td>
                                                <td class="pb-2 font-size-18 text-capitalize">
                                                    <template v-if="templateArr.categories && templateArr.categories.length > 0">
                                                        <template>
                                                            {{getCtaegories}}
                                                        </template>
                                                    </template>
                                                    <template v-else><em class="text--secondary">-</em></template>
                                                </td>
                                            </tr> -->
                                            <tr>
                                                <td class="pb-2 font-size-18 font-weight-500 text-capitalize">
                                                    Added By
                                                </td>
                                                <td class="pb-2 font-size-18 text-capitalize">
                                                    <template v-if="templateArr.added_by">
                                                        <template
                                                            v-if="templateArr.added_by && templateArr.added_by.display_name">
                                                            {{ templateArr.added_by.display_name }}
                                                        </template>
                                                    </template>
                                                    <template v-else><em class="text--secondary">-</em></template>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="pb-2 font-size-18 font-weight-500 text-capitalize">
                                                    Added At
                                                </td>
                                                <td class="pb-2 font-size-18 text-capitalize">
                                                    <template v-if="templateArr.created_at">
                                                        <template>
                                                            {{ templateArr.created_at }}
                                                        </template>
                                                    </template>
                                                    <template v-else><em class="text--secondary">-</em></template>
                                                </td>
                                            </tr>
                                        </table>
                                    </v-col>
                                    <v-col md="8">
                                        <perfect-scrollbar ref="sidebarScrollbar" :options="{ suppressScrollX: true }"
                                            class="scroll" style="max-height: 89vh; position: relative">
                                            <template v-if="templateArr && templateArr.checklist_data">
                                                <FormBuilderPreview :data="templateArr.checklist_data" />
                                            </template>
                                        </perfect-scrollbar>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </template>
                    </v-tab-item>
                    <v-tab-item :value="'equipment'">
                        <template>
                            <ChecklistCategory 
                            :detail="templateArr"
                             type="checklist"
                            :is-customer="false"
                            :checklist-id="seviceTemplate"
                            @refresh-checklist="getServiceFormTemplate"
                             />
                        </template>
                    </v-tab-item>
                </v-tabs-items>
            </perfect-scrollbar>
        </template>
        <template v-slot:footer> </template>
    </DetailTemplate>

</template>

<script>
import CommonMixin from "@/core/plugins/common-mixin";
import FormBuilderPreview from "@/view/pages/serviceFormTemplate/FormBuilderPreview";
import { GET } from "@/core/services/store/request.module";
import DetailTemplate from "@/view/pages/partials/Detail-Template.vue";
import ChecklistCategory from "@/view/pages/serviceFormTemplate/ChecklistCategory.vue";
import { map } from "lodash";

export default {
    mixins: [CommonMixin],
    name: "serviceFormTemplate-detail",
    title: "Service Form Template",
    data() {
        return {
            seviceTemplate: null,
            templateTab: "",
            pageLoading: true,
            templateArr: {},
            fileArr: [],
        };
    },
    components: {
        FormBuilderPreview,
        DetailTemplate,
        ChecklistCategory
    },
    methods: {
        updateServiceFormTemplate() {
            const _this = this;
            this.$router.push(_this.getDefaultRoute('serviceFormTemplate.update', { params: { id: _this.seviceTemplate } }))
        },
        getStatus(status) {
            if (status == 1) {
                return "Active";
            }
            return "In-Active";
        },
        getColor(status) {
            if (status == 1) {
                return "green white--text";
            }
            return "red white--text";
        },
        GetPosition(data) {
            switch (Number(data)) {
                case 1:
                    return 'Left';
                case 2:
                    return 'Middle';
                case 3:
                    return 'Right';
            }
            return '';
        },
        getServiceFormTemplate() {
            const _this = this;
            _this.$store
                .dispatch(GET, {
                    url: "setting/checklist/" + _this.seviceTemplate,
                })
                .then(({ data }) => {
                    _this.templateArr = data;
                })
                .catch((error) => {
                    _this.logError(error);
                    _this.goBack();
                })
                .finally(() => {
                    _this.pageLoading = false;
                });
        },
        assignEquipment() {
            this.$router.push({
                name: 'equipment',
                query: {
                    checklist_id: this.seviceTemplate,
                    assign_mode: 'checklist'
                }
            });
        },
    },
    mounted() {
        const _this = this;
        _this.getServiceFormTemplate();
    },
    created() {
        const _this = this;
        _this.seviceTemplate = _this.lodash.toSafeInteger(_this.$route.params.id);
    },
    computed: {

        getCtaegories()
        {
            if(this.templateArr && this.templateArr.categories && this.templateArr.categories.length > 0)
            {
                let category = map(this.templateArr.categories, (row) => row.text);
                return category.join(', ');
            }
            return '';
        },
        getPageTitle() {
            let result = [];
            if (this.lodash.isEmpty(this.templateArr) === false) {
                if (this.templateArr.title) {
                    result.push(this.templateArr.title);
                }
                if (this.templateArr.barcode) {
                    result.push(this.templateArr.barcode);
                }
            }
            return result.join(" • ");
        },
    },
};
</script>
